// Global feature flags. Change these values via a PR to toggle features.

// When false, the Edit Mode toggle is hidden and the app is read-only.
export const EDIT_MODE_ENABLED = false;
